export const REQUESTED_2FA_TIME = 'requested-2fa-time'
export const AUTHENTICATED_2FA_TIME = 'authenticated-2fa-time'
export const MAX_CODE_ATTEMPTS = 5
export const EXPIRED_CODE_ERROR = 'FALHA_DURANTE_AUTENTICACAO'
